import { DOWNLOAD,ERR_DOWNLOAD,LOADING} from "./actions";

const initialState = {
 data:{},
 error : {},
 loading : false
};

const requestPdfReducer = (state = initialState, action) => {
  const { type, data, error,loading} = action;
  
  switch (type) {
    case DOWNLOAD:
      return { ...state,data};
    case ERR_DOWNLOAD:
        return { ...state, error};   
    case LOADING:
        return { ...state, loading}        
    default:
      return state;
  }
};

export default requestPdfReducer;
